import React from 'react';
import { Link } from 'react-router-dom';
import CircuitAnimation from './CircuitAnimation';

const Hero: React.FC = () => {
    return (
        <section id="hero" className="w-full h-full mt-20 md:mt-24 pt-24 pb-12 md:pt-32 md:pb-20 bg-background">
            {/* Accent elements */}
            <div className="absolute top-0 left-0 w-full h-1 bg-accent"></div>
            
            <div className="w-full px-4 md:px-8 lg:px-12">
                <div className="max-w-7xl mx-auto grid md:grid-cols-[1fr_auto] gap-12 items-center">
                    {/* Left side - Main content */}
                    <div className="relative z-10 space-y-10 animate-fade-in-up">
                        <h1 className="text-6xl md:text-7xl xl:text-8xl font-bold tracking-tight leading-none font-display">
                            MICHAL<br/>CHAMRÁD
                        </h1>
                        
                        <p className="text-xl md:text-3xl font-bold max-w-2xl font-body">
                            Building digital ventures where systems meet people.
                        </p>

                        {/* CTA */}
                        <div className="inline-block">
                            <Link 
                                to="/contact" 
                                className="inline-block bg-accent text-background text-xl font-bold px-8 py-3 
                                        hover:bg-surface hover:text-accent transition-all duration-300 hover:shadow-brutal font-accent"
                            >
                                LET&apos;S WORK TOGETHER →
                            </Link>
                        </div>
                    </div>

                    {/* Right side - Image with circuit animation */}
                    <div className="relative animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                        <div className="w-48 h-48 md:w-[300px] md:h-[300px] relative hover:transform transition-all duration-200 group">
                            {/* Circuit animation vycházející z obrázku */}
                            <div className="pointer-events-none absolute w-[200%] h-[200%] -translate-x-1/4 -translate-y-1/4 overflow-visible">
                                <CircuitAnimation />
                            </div>
                            
                            <img 
                                src="/assets/me_new.jpg" 
                                alt="Michal Chamrád" 
                                className="w-full h-full object-cover border-4 border-surface-alt shadow-brutal relative z-10
                                          group-hover:-translate-y-2 group-hover:shadow-brutal-lg group-hover:border-[5px] 
                                          transition-all duration-200"
                            />
                            <div className="absolute inset-0 border-4 border-accent transform translate-x-2 translate-y-2 -z-10
                                          group-hover:translate-x-4 group-hover:translate-y-4 group-hover:border-[5px]
                                          transition-all duration-200"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;